import { IDeviceDetectors } from "@types"
import { protectedApi } from "store/Api"

const deviceDetectorsApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchDeviceDetectors: builder.query<IDeviceDetectors[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/detectors`,
                }
            },
        }),
    }),
})

export const { useFetchDeviceDetectorsQuery } = deviceDetectorsApi
